import { raiseErrorToast } from '@celito.clients/utils';
import { PopoverProps } from '@fluentui/react-components';
import { useEffect, useState } from 'react';

import { getStageHistory } from '../workflow-history/workflow-actions/services';
import { WizardStateComponentProps } from './wizard-state.model';
import WizardStateView from './wizard-state.view';

export const WizardStateController = (props: WizardStateComponentProps) => {
  const [open, setOpen] = useState(false);
  const [taskGroupNames, setTaskGroupNames] = useState<string[]>([]);
  const [stagesLoading, setStagesLoading] = useState(true);
  const handleOpenChange: PopoverProps['onOpenChange'] = (e, data) => {
    // check if the id's dropdown options and no result options are in view port then keep open the workflow history
    // else let event handle the selection
    const target = e.currentTarget as EventTarget & (HTMLElement | Document);

    if (target instanceof HTMLElement || target instanceof Document) {
      const dropdownWithOptions = target.querySelector(
        '#dropdown-with-options'
      );
      const dropdownWithoutOptions = target.querySelector(
        '#dropdown-with-no-results'
      );
      if (dropdownWithOptions || dropdownWithoutOptions) {
        setOpen(true);
      } else {
        setOpen(data.open || false);
      }
    } else {
      setOpen(data.open || false);
    }
  };

  useEffect(() => {
    fetchStageHistory();
  }, [props?.recordName, props?.objectName]);

  const fetchStageHistory = async () => {
    setStagesLoading(true);
    try {
      if (props?.objectName && props?.recordName) {
        const stageHistory = await getStageHistory(
          props.objectName,
          props.recordName
        );

        // Collect unique group labels for completed stages
        const completedGroups: string[] = [];
        for (const stage of stageHistory?.stages ?? []) {
          if (stage.completed && !completedGroups.includes(stage.groupLabel)) {
            completedGroups.push(stage.groupLabel);
          }
        }
        setTaskGroupNames(completedGroups);
      }
    } catch (error) {
      raiseErrorToast(error);
    } finally {
      setStagesLoading(false);
    }
  };

  return (
    <WizardStateView
      {...props}
      loading={stagesLoading}
      handleOpenChange={handleOpenChange}
      open={open}
      taskGroupNames={taskGroupNames}
    />
  );
};
